export default __webpack_public_path__ + "static/media/paypalDonate.ff0872bb.png";